export default __webpack_public_path__ + "static/media/3_fooddiary__october.e32dc9ed.jpg";